export const RECOMMENDATIONS_LOADING = 'RECOMMENDATIONS_LOADING';
export const RECOMMENDATIONS_SUCCESS = 'RECOMMENDATIONS_SUCCESS';
export const RECOMMENDATIONS_ERROR = 'RECOMMENDATIONS_ERROR';
export const RECOMMENDATIONS_CLEAR = 'RECOMMENDATIONS_CLEAR';
